var _defineProperty = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/1/Terralego/Customers/fedescot/fedescot-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

(function (a, b) {
  if ("function" == typeof define && define.amd) define(["exports", "@babel/runtime/helpers/extends", "@babel/runtime/helpers/objectWithoutProperties", "react", "prop-types", "classnames"], b);else if ("undefined" != typeof exports) b(exports, require("@babel/runtime/helpers/extends"), require("@babel/runtime/helpers/objectWithoutProperties"), require("react"), require("prop-types"), require("classnames"));else {
    var c = {
      exports: {}
    };
    b(c.exports, a._extends, a.objectWithoutProperties, a.react, a.propTypes, a.classnames), a.HeaderLink = c.exports;
  }
})("undefined" == typeof globalThis ? "undefined" == typeof self ? this : self : globalThis, function (a, b, c, d, e, f) {
  "use strict";

  var g = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = a.HeaderLink = void 0, b = g(b), c = g(c), d = g(d), e = g(e), f = g(f);

  var h = function h(a) {
    var e = a.className,
        g = a.href,
        h = a.link,
        i = (0, c.default)(a, ["className", "href", "link"]);
    var j = h || {
      component: g ? "a" : "span",
      linkProps: {
        hrefAttribute: "href"
      }
    },
        k = j.component,
        l = j.linkProps,
        m = l.hrefAttribute,
        n = (0, c.default)(l, ["hrefAttribute"]);
    return d.default.createElement(k, (0, b.default)({
      className: (0, f.default)(["header-link", e])
    }, g && _defineProperty({}, m, g), n, i));
  };

  a.HeaderLink = h, h.propTypes = {
    children: e.default.element.isRequired,
    className: e.default.string,
    href: e.default.string,
    link: e.default.shape({
      component: e.default.oneOfType([e.default.func, e.default.elementType, e.default.string]),
      linkProps: e.default.shape({
        hrefAttribute: e.default.string
      })
    })
  }, h.defaultProps = {
    className: "",
    href: "",
    link: void 0
  };
  a.default = h;
});